import { TFunction } from "i18next";
import { z } from "zod";
import { nullableNumber } from "../../../utils";

export const getExtractionEquipmentFormSchema = (t: TFunction) => {
  const numberField = nullableNumber(t("generic.errors.invalid-number"));
  return z.object({
    equipmentType: z.string().nullable().optional(),
    equipmentBrandId: z.number().nullable().optional(),
    equipmentModel: z.string().nullable().optional(),
    equipmentPower: numberField.optional(),
    equipmentDepth: numberField.optional(),
  });
};

export type ExtractionEquipmentForm = z.infer<ReturnType<typeof getExtractionEquipmentFormSchema>>;